const monthlyUsdPrice = (unitAmount) => Object.freeze({
  unitAmount,
  currency: 'usd',
  interval: 'month',
  intervalCount: 1,
});

export const PUBLISHED_SUBSCRIPTION_PLANS = Object.freeze({
  single: Object.freeze({
    accountMode: 'single',
    planName: 'Single Mode',
    price: monthlyUsdPrice(1000),
  }),
  team: Object.freeze({
    accountMode: 'team',
    planName: 'Team Mode',
    price: monthlyUsdPrice(1800),
  }),
});

export const getPublishedSubscriptionPlan = (accountMode) =>
  PUBLISHED_SUBSCRIPTION_PLANS[accountMode] || PUBLISHED_SUBSCRIPTION_PLANS.single;

export const formatSubscriptionPrice = (price, locale) => {
  if (!Number.isInteger(price?.unitAmount) || !price?.currency) return null;

  try {
    const currency = price.currency.toUpperCase();
    const currencyDefaults = new Intl.NumberFormat(locale, {
      style: 'currency',
      currency,
    });
    const fractionDigits = currencyDefaults.resolvedOptions().maximumFractionDigits;
    const minorUnitScale = 10 ** fractionDigits;
    const formatter = new Intl.NumberFormat(locale, {
      style: 'currency',
      currency,
      minimumFractionDigits: price.unitAmount % minorUnitScale === 0 ? 0 : fractionDigits,
      maximumFractionDigits: fractionDigits,
    });
    return formatter.format(price.unitAmount / minorUnitScale);
  } catch (error) {
    return null;
  }
};

export const formatSubscriptionInterval = (price) => {
  const interval = price?.interval;
  const count = Number(price?.intervalCount) || 1;
  if (!interval) return null;
  return count === 1 ? interval : `${count} ${interval}s`;
};
